import React, { useEffect, useState, useCallback } from 'react';
import { NavLink } from 'react-router-dom';
import { FaEyeSlash } from 'react-icons/fa';
import base_url from '../config/Config';
import Sidebar from '../components/Sidebar';
import Navigation from '../components/Navigation';
import axios from 'axios';
import Spinner from 'react-bootstrap/Spinner';
import PageLoader from '../components/PageLoader';

const Reject = () => {
    const [rejects, setRejects] = useState([]);
    const [rejectedLoans, setRejectedLoans] = useState([]);
    const [pageLoading, setPageLoading] = useState(true);
    const [filteredRejects, setFilteredRejects] = useState([]);
    const [isDownloading, setIsDownloading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [activeTab, setActiveTab] = useState('customer');
    const [searchOption, setSearchOption] = useState('');
    const [searchInput, setSearchInput] = useState('');
    const itemsPerPage = 50;

    const getRejectedCustomers = useCallback(() => {
        const token = localStorage.getItem('token') || '';
        axios.get(`${base_url}/api/customer/rejected`, {
            headers: { Authorization: `Bearer ${token}` }
        })
        .then(res => {
            setRejects(res.data || []);
            setFilteredRejects(res.data || []);
        })
        .catch(err => console.error(err))
        .finally(() => setPageLoading(false));
    }, []);

    const getRejectedLoans = useCallback(() => {
        const token = localStorage.getItem('token') || '';
        axios.get(`${base_url}/api/reject/rejectedCustomers`, {
            headers: { Authorization: `Bearer ${token}` }
        })
        .then(res => {
            setRejectedLoans((res.data || []).sort((a, b) => b.id - a.id));
        })
        .catch(err => console.error(err));
    }, []);

    useEffect(() => {
        getRejectedCustomers();
        getRejectedLoans();
    }, [getRejectedCustomers, getRejectedLoans]);

    // Export
    const handleExport = async () => {
        setIsDownloading(true);
        const token = localStorage.getItem('token') || '';
        try {
            const res = await axios.get(`${base_url}/api/export/rejectedCustomers`, {
                headers: { Authorization: `Bearer ${token}` },
                responseType: 'blob'
            });
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Rejected_Customers.xlsx');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error(error);
            alert('Export failed');
        } finally {
            setIsDownloading(false);
        }
    };

    // Search
    const handleSearch = (e) => {
        e.preventDefault();
        let filtered = [...rejects];
        if (searchOption && searchInput) {
            switch (searchOption) {
                case 'borrower_name':
                    filtered = filtered.filter(item => item.borrowerName?.toLowerCase().includes(searchInput.toLowerCase()));
                    break;
                case 'mobile':
                    filtered = filtered.filter(item => item.mobileNumber?.includes(searchInput));
                    break;
                case 'pan':
                    filtered = filtered.filter(item => item.panNumber?.toLowerCase().includes(searchInput.toLowerCase()));
                    break;
                case 'agent_name':
                    filtered = filtered.filter(item => item.employeeName?.toLowerCase().includes(searchInput.toLowerCase()));
                    break;
                case 'agent_code':
                    filtered = filtered.filter(item => item.employeeId?.toString().includes(searchInput));
                    break;
                default: break;
            }
        }
        setFilteredRejects(filtered);
        setCurrentPage(1);
    };

    // Pagination
    const activeData = activeTab === 'loan' ? rejectedLoans : filteredRejects;
    const indexOfLast = currentPage * itemsPerPage;
    const indexOfFirst = indexOfLast - itemsPerPage;
    const currentItems = activeData.slice(indexOfFirst, indexOfLast);
    const totalPages = Math.ceil(activeData.length / itemsPerPage);
    const maxPageButtons = 10;

    const getPaginationRange = () => {
        const mid = Math.floor(maxPageButtons / 2);
        let start = Math.max(1, currentPage - mid);
        let end = Math.min(totalPages, start + maxPageButtons - 1);
        if (end - start < maxPageButtons - 1) start = Math.max(1, end - maxPageButtons + 1);
        return { start, end };
    };

    const { start: startPage, end: endPage } = getPaginationRange();

    return (
        <>
            <div className='overviewsaa'>
                <h4>Rejected Customers</h4>
            </div>

            <div className='navigationss mb-5'>
                <Navigation />
            </div>

            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-lg-2 col-md-2 sidebarnavigartion'>
                        <div className='lmssidebar'>
                            <Sidebar />
                        </div>
                    </div>

                    <div className='col-lg-10 col-md-10'>
                        <div className='dashboardlms  text-center'>

                            {/* Search & Export */}
                            <div className='row mb-4'>
                                <div className='col-md-12'>
                                    <form onSubmit={handleSearch} className='row g-2 align-items-center'>
                                        <div className="col-md-3">
                                            <select
                                                className="form-control"
                                                value={searchOption}
                                                onChange={(e) => setSearchOption(e.target.value)}
                                            >
                                                <option value="">Search By</option>
                                                <option value="borrower_name">Customer Name</option>
                                                <option value="mobile">Mobile</option>
                                                <option value="pan">PAN</option>
                                                <option value="agent_name">Agent Name</option>
                                                <option value="agent_code">Agent Code</option>
                                            </select>
                                        </div>

                                        <div className="col-md-4">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Search..."
                                                value={searchInput}
                                                onChange={(e) => setSearchInput(e.target.value)}
                                            />
                                        </div>

                                        <div className="col-md-2">
                                            <button type="submit" className="btn btn-sm btn-primary">Search</button>
                                        </div>

                                        <div className="col-md-3">
                                            <button className="btn btn-success" type="button" onClick={handleExport}>
                                                {isDownloading ? <Spinner animation="border" size="sm" /> : 'Export'}
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>

                            {/* Tabs */}
                            <div className='loan-tabs mt-2'>
                                <button
                                    className={`loan-tab-btn${activeTab === 'customer' ? ' loan-tab-active loan-tab-rejected' : ''}`}
                                    onClick={() => { setActiveTab('customer'); setCurrentPage(1); }}
                                >
                                    Customer Rejected ({rejects.length})
                                </button>
                                <button
                                    className={`loan-tab-btn${activeTab === 'loan' ? ' loan-tab-active loan-tab-rejected' : ''}`}
                                    onClick={() => { setActiveTab('loan'); setCurrentPage(1); }}
                                >
                                    Loan Rejected ({rejectedLoans.length})
                                </button>
                            </div>

                            {/* Table */}
                            <div className='row'>
                                <div className='col-md-12 mb-5 mt-3'>
                                    <div className='allcustomer table-responsive'>
                                        {pageLoading ? <PageLoader text="Loading..." /> : currentItems.length > 0 ? (
                                            <table className="styled-table">
                                                <thead>
                                                    <tr>
                                                        <th>S.N.</th>
                                                        <th>Customer Name</th>
                                                        <th>Customer ID</th>
                                                        <th>PAN</th>
                                                        <th>Mobile</th>
                                                        <th>Agent Name</th>
                                                        <th>Agent Code</th>
                                                        <th>Create Date</th>
                                                        <th>Status</th>
                                                        <th>View</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {currentItems.map((item, index) => (
                                                        <tr key={item.id}>
                                                            <td>{index + 1 + (currentPage - 1) * itemsPerPage}</td>
                                                            <td>{item.borrowerName}</td>
                                                            <td>{item.id}</td>
                                                            <td>{item.panNumber}</td>
                                                            <td>{item.mobileNumber}</td>
                                                            <td>{item.employeeName}</td>
                                                            <td>{item.employeeId}</td>
                                                            <td>{item.createDate}</td>
                                                            <td>
                                                                <span className="badge bg-danger">
                                                                    {activeTab === 'loan' ? 'Loan Rejected' : 'Customer Rejected'}
                                                                </span>
                                                            </td>
                                                            <td>
                                                                <NavLink to={`/operation/ViewVerifiedCustomer?id=${item.id}`}>
                                                                    <FaEyeSlash />
                                                                </NavLink>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        ) : (
                                            <p className="empty-state">
                                                {activeTab === 'loan' ? 'Koi rejected loan nahi mila.' : 'No rejected customers found.'}
                                            </p>
                                        )}
                                    </div>
                                </div>
                            </div>

                            {/* Pagination */}
                             {/* Pagination */}
                                    <div className="pagination-container">
                                        <div className="pagination-box">
                                            {startPage > 1 && (
                                                <>
                                                    <button onClick={() => setCurrentPage(1)}>1</button>
                                                    <span className="dots">...</span>
                                                </>
                                            )}
                                            {Array.from({ length: endPage - startPage + 1 }, (_, i) => (
                                                <button
                                                    key={startPage + i}
                                                    className={currentPage === startPage + i ? 'active' : ''}
                                                    onClick={() => setCurrentPage(startPage + i)}
                                                >
                                                    {startPage + i}
                                                </button>
                                            ))}
                                            {endPage < totalPages && (
                                                <>
                                                    <span className="dots">...</span>
                                                    <button onClick={() => setCurrentPage(totalPages)}>{totalPages}</button>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </div>

                        </div>
                    </div>
                </div>
        </>
    );
};

export default Reject;
